import React, { useState } from 'react';
import './index.css';
import { useNavigate } from 'react-router-dom';

interface Service {
  title: string;
  description: string;
  details: string;
  link?: string;
}

const Services: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<number | null>(0); // Default to first category
  const [flippedCards, setFlippedCards] = useState<number[]>([]);

  const navigate = useNavigate();
  const handleCardFlip = (index: number) => {
    if (flippedCards.includes(index)) {
      setFlippedCards(flippedCards.filter(i => i !== index));
    } else {
      setFlippedCards([...flippedCards, index]);
    }
  };
  const serviceCategories: { category: string; services: Service[] }[] = [
    {
      category: 'Websites',
      services: [
        { title: 'Static Websites', description: 'Entry-level sites with fast cloud hosting.', details: 'Professional web presence, email-linked contact pages, Google-friendly SEO, cloud caching, and low monthly hosting fees.' },
        { title: 'Ecommerce and Payments', description: 'Online storefronts and payment integrations.', details: 'Product pages, checkout flows, payment provider integrations, shipping logic, customer communication, and custom ordering experiences.' },
        { title: 'Customer Tools', description: 'Scheduling, SMS, logins, and chatbots.', details: 'Customer logins, appointment scheduling, SMS messaging, friendly chatbots, AI integrated intelligent chatbots, forms, analytics, and business integrations.' },
      ],
    },
    {
      category: 'Apps',
      services: [
        { title: 'Mobile App Development', description: 'Simple presence apps through full customer tools.', details: 'Custom mobile apps, customer logins, profile management, previous orders, SMS messaging, scheduling, ordering, and service request flows.' },
        { title: 'Cloud Applications', description: 'Scalable app architecture and deployment.', details: 'AWS, Azure, and GCP application design with APIs, databases, authentication, storage, monitoring, and cost-aware operations.' },
        { title: 'AI and Automation', description: 'Smarter workflows and business integrations.', details: 'Friendly chatbots, AI integrated intelligent chatbots, RAG solutions, AI-assisted workflows, data integrations, and practical automations for repetitive business tasks.' },
      ],
    },
    {
      category: '3D Printing',
      services: [
        { title: 'Business and Event Prints', description: 'Promotional prints and party keepsakes.', details: 'Business magnets, name badges, custom party favors, license plates, card trays, and branded pieces for meetings, events, and customers.' },
        { title: 'Personalized Gifts', description: 'Photos, names, characters, and fan gear.', details: 'Lithophanes, keychains, character creatures, custom fan pendants, sports jersey designs, keepsakes, and personalized product ideas.' },
        { title: 'Fidgets and Custom Ideas', description: 'Fun desk pieces and small-batch designs.', details: 'Fidgets, clickers, logos, animals, prototypes, concept models, sizing help, color choices, and preparing ideas for production.' },
      ],
    },
  ];

  return (
    <div className="services-container">
      <section className="services-intro">
        <h1>Hogcloud Services</h1>
        <p>
          Hogcloud provides website development, custom app development, cloud
          software, AI automation, and custom 3D printing for small businesses,
          creators, families, and local organizations.
        </p>
      </section>

      <div className="category-buttons">
        {serviceCategories.map((category, index) => (
          <button
            key={index}
            className={`category-button ${activeCategory === index ? 'active' : ''}`}
            onClick={() => setActiveCategory(index)}
          >
            {category.category}
          </button>
        ))}
      </div>

      <div className="service-cards">
        {serviceCategories[activeCategory!].services.map((service, index) => (
          <div key={index} className={`service-card ${flippedCards.includes(index) ? 'flipped' : ''}`} onClick={() => handleCardFlip(index)}>
            <div className="card-inner">
              <div className="card-front">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
              <div className="card-back">
                <p>{service.details} 
                <button onClick={() => navigate('/contact')}>Learn More</button>

                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
